<template>
    <div class="panel panel-info">
        <div class="panel-heading"><h4 class="panel-title"><i class="fa fa-book"></i>编辑专业</h4></div>
        <div class="panel-body">
            <div class="row">
                <form class="form-horizontal" >
                    <!-- 轮次-->
                    <div class="col-sm-12">
                        <div class="col-sm-6">
                            <div class="form-group">
                                <label class="col-sm-3 control-label" > <span class="required" >*</span>轮次</label>
                                <div class="col-sm-9">
                                    <input type="text" name="lunci" v-model="model.lunci" v-validate="{required:true,max:100}" class="form-control" data-vv-as="轮次" placeholder=""/>
                                    <span class="error_validate_msg"><em>{{ errors.first('lunci') }}</em></span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--专业代码/国编代码-->
                    <div class="col-sm-12">
                        <div class="col-sm-6">
                            <div class="form-group">
                                <label class="col-sm-3 control-label" > <span class="required" >*</span>专业代码</label>
                                <div class="col-sm-9">
                                    <input type="text" name="zydm" v-model="model.zydm" v-validate="{required:true,max:100}" class="form-control" data-vv-as="专业代码" placeholder=""/>
                                    <span class="error_validate_msg"><em>{{ errors.first('zydm') }}</em></span>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="form-group">
                                <label class="col-sm-3 control-label" >国编代码</label>
                                <div class="col-sm-9">
                                    <input type="text" name="gbdm" v-model="model.gbdm" v-validate="{max:100}" class="form-control" placeholder=""/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--专业名称/是否统考-->
                    <div class="col-sm-12">
                        <div class="col-sm-6">
                            <div class="form-group">
                                <label class="col-sm-3 control-label" > <span class="required" >*</span>专业名称</label>
                                <div class="col-sm-9">
                                    <input type="text" name="zymc" v-model="model.zymc" v-validate="{required:true}" class="form-control" data-vv-as="专业名称" placeholder=""/>
                                    <span class="error_validate_msg"><em>{{ errors.first('zymc') }}</em></span>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="form-group">
                                <label class="col-sm-3 control-label" > <span class="required" >*</span>是否统考</label>
                                <div class="col-sm-9">
                                    <select name="sftk" v-model="model.sftk" class="form-control" data-vv-as="是否统考" v-validate="{required:true}">
                                        <option value="">-请选择-</option>
                                        <option value="0">否</option>
                                        <option value="1">是</option>
                                    </select>
                                    <span class="error_validate_msg"><em>{{ errors.first('sftk') }}</em></span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--专业层次/总学分-->
                    <div class="col-sm-12">
                        <div class="col-sm-6">
                            <div class="form-group">
                                <label class="col-sm-3 control-label" > <span class="required" >*</span>专业层次</label>
                                <div class="col-sm-9">
                                    <select name="zycc" v-model="model.zycc" class="form-control" data-vv-as="专业层次" v-validate="{required:true}">
                                        <option value="">-请选择-</option>
                                        <option value="A">专科</option>
                                        <option value="B">本科</option>
										<option value="C">高起本</option>
                                    </select>
                                    <span class="error_validate_msg"><em>{{ errors.first('zycc') }}</em></span>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="form-group">
                                <label class="col-sm-3 control-label" > <span class="required" >*</span>毕业总学分</label>
                                <div class="col-sm-9">
                                    <input type="text" name="zxf" v-model="model.zxf" v-validate="{required:true,max:100}" class="form-control" data-vv-as="毕业总学分" placeholder=""/>
                                    <span class="error_validate_msg"><em>{{ errors.first('zxf') }}</em></span>
                                </div>
                            </div>
                        </div>
                    </div>
					<!--高起本-->
					<div class="col-sm-12" v-if="model.zycc=='C'">
					    <div class="col-sm-6">
					        <div class="form-group">
					            <label class="col-sm-3 control-label" > <span class="required" >*</span>专科专业</label>
					            <div class="col-sm-9">
									<BootstrapCombobox :data="zyaList" name="zyaId" text-field="zymc"
										value-field="id" v-model="model.zyaId" placeholder="-专业筛选-"  data-vv-as="专科段专业"
										v-validate="{required:true}" :formatOption="(item)=>(item.zydm + '-'+item.zymc)"></BootstrapCombobox>
					                <span class="error_validate_msg"><em>{{ errors.first('zyaId') }}</em></span>
					            </div>
					        </div>
					    </div>
					    <div class="col-sm-6">
					        <div class="form-group">
					            <label class="col-sm-3 control-label"><span class="required">*</span>本科专业</label>
					           <div class="col-sm-9">
					           	<BootstrapCombobox :data="zybList" name="zybId" text-field="zymc"
					           		value-field="id" v-model="model.zybId" placeholder="-专业筛选-"  data-vv-as="本科段专业"
					           		v-validate="{required:true}" :formatOption="(item)=>(item.zydm + '-'+item.zymc)"></BootstrapCombobox>
					               <span class="error_validate_msg"><em>{{ errors.first('zybId') }}</em></span>
					           </div>
					        </div>
					    </div>
					</div>
                    <!--一级学科/二级学科-->
                    <div class="col-sm-12">
                        <div class="col-sm-6">
                            <div class="form-group">
                                <label class="col-sm-3 control-label" > <span class="required" >*</span>一级学科</label>
                                <div class="col-sm-9">
                                    <select name="xka" v-model="model.xka" class="form-control" v-validate="{required:true}" data-vv-as="一级学科" @change="getXkb">
                                        <option value="">-请选择-</option>
										 <option v-for="item in xkaList" :key="item.xkdm" :value="item.xkdm">{{item.xkdm}}-{{item.xkmc}}</option>
                                    </select>
                                    <span class="error_validate_msg"><em>{{ errors.first('xka') }}</em></span>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="form-group">
                                <label class="col-sm-3 control-label"><span class="required">*</span>二级学科</label>
                                <div class="col-sm-9">
                                    <select name="xkId" v-model="model.xkId" class="form-control" v-validate="{required:true}" data-vv-as="二级学科">
                                        <option value="">-请选择-</option>
                                        <option v-for="item in xkbList" :key="item.id" :value="item.id">{{item.xkdm}}-{{item.xkmc}}</option>
                                    </select>
                                    <span class="error_validate_msg"><em>{{ errors.first('xkId') }}</em></span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--开考状态/开考时间-->
                    <div class="col-sm-12" style="margin-top: 6px">
                        <div class="col-sm-6">
                            <div class="form-group">
                                <label class="col-sm-3 control-label" > <span class="required" >*</span>开考状态</label>
                                <div class="col-sm-9">
                                    <select name="kkzt" v-model="model.kkzt" class="form-control" data-vv-as="开考状态" v-validate="{required:true}">
                                        <option value="">-请选择-</option>
                                        <option value="OK">开考</option>
                                        <option value="BLOCK">停考</option>
                                    </select>
                                    <span class="error_validate_msg"><em>{{ errors.first('kkzt') }}</em></span>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="form-group">
                                <label class="col-sm-3 control-label" ><span class="required" >*</span>开考时间</label>
                                <div class="col-sm-9">
                                    <DateTimePicker v-model="model.kksj" name="kksj" v-validate="{required:true}" data-vv-as="开考时间" format="YYYY-MM-DD" input-class="form-control" style="width:300px" :show-buttons="true" clearable></DateTimePicker>
                                    <div>
                                        <span class="error_validate_msg" ><em>{{ errors.first('kksj') }}</em></span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--是否报考/学历类型-->
                    <div class="col-sm-12">
                        <div class="col-sm-6">
                            <div class="form-group">
                                <label class="col-sm-3 control-label" > <span class="required" >*</span>是否报考</label>
                                <div class="col-sm-9">
                                    <select name="sfbk" v-model="model.sfbk" class="form-control">
                                        <option value="">-请选择-</option>
                                        <option value="0">否</option>
                                        <option value="1">是</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="form-group">
                                <label class="col-sm-3 control-label" > <span class="required" >*</span>学历类型</label>
                                <div class="col-sm-9">
                                    <select name="xllx" v-model="model.xllx" class="form-control" data-vv-as="学历类型" v-validate="{required:true}">
                                        <option value="">-请选择-</option>
                                        <option value="ZXKS">自学考试</option>
                                        <option value="CRJY">成人教育</option>
                                        <option value="WLJY">网络教育</option>
										<option value="GJKFDX">国家开放大学</option>
                                    </select>
                                    <span class="error_validate_msg"><em>{{ errors.first('xllx') }}</em></span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--试卷说明-->
                    <div class="col-sm-12">
                        <div class="col-sm-6">
                            <div class="form-group">
                                <label class="col-sm-3 control-label">报考条件备注</label>
                                <div class="col-sm-9">
                                    <textarea class="form-control"  v-model="model.bkbz" rows="5"></textarea>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="form-group">
                                <label class="col-sm-3 control-label">备注</label>
                                <div class="col-sm-9">
                                    <textarea class="form-control"  v-model="model.bz" rows="5"></textarea>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--按钮-->
                    <div class="col-sm-12 text-center" style="margin-top: 30px">
                        <div class="form-group">
                            <button @click="save()" type="button" class="btn btn-primary btn-sm " style="margin-right:3px"><i class="" aria-hidden="true"></i>提交</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>
<script>

    /**
     * 专业信息管理-新增
     */
    export default {
        name:"SpecialtyEdit",
        data:function(){
            return {
                xkaList:[], //一级学科
                xkbList:[],//二级学科
				zyaList:[],//专科专业
				zybList:[],//本科专业
                model:{
					id:this.$route.query.id,
                    lunci:'',
                    zydm:'',
					gbdm:'',
					zymc:'',
					sftk:'',
					zycc:'',
					zxf:'',
					xka:'',
					xkId:'',
					kkzt:'',
					kksj:'',
					sfbk:'',
					xllx:'',
					bkbz:'',
					bz:'',
					zyaId:'',
					zybId:''
                }
            }
        },
        created:function(){
            this.$store.commit('setBreadcrumb',[{name:'基础数据'},{name:'专业计划管理'},{name:'专业信息管理'},{name:'编辑专业'}]);
            this.$store.commit('setShowReturnBackBtn',true);
			this.init();
        },
        methods: {
			async init(){
				let res = await this.$http.post('/htgl/inf/xk/yjxk');
				if(res.data){
					this.xkaList = res.data;
				}
				res = await this.$http.post('/htgl/inf/zy/getZyByZycc',{zycc:'A'});
				if(res.data){
					this.zyaList = res.data;
				}
				res = await this.$http.post('/htgl/inf/zy/getZyByZycc',{zycc:'B'});
				if(res.data){
					this.zybList = res.data;
				}
				if(this.model.id){
					res =await this.$http.post('/htgl/inf/zy/hq',{id:this.model.id});
					if(res.data){
						this.model = res.data.zy;
						this.model.xka = res.data.xka.xkdm;
						if (this.model.xka) {
						    res =await this.$http.post('/htgl/inf/xk/ejxk',{xkdm:this.model.xka});
							if(res.data){
								this.xkbList = res.data;
							}
						}
					}
				}
			},
            getXkb: function () {
				this.model.xkId = '';
                if (this.model.xka) {
                    this.$http.post('/htgl/inf/xk/ejxk',{xkdm:this.model.xka}).then(res => {
                    	if(res.data){
                    		this.xkbList = res.data;
                    	}
                    });
                }
            },
			getZyaList: function () {//专科专业
			    this.$http.post('/htgl/inf/zy/getZyByZycc',{zycc:'A'}).then(res => {
					if(res.data){
						this.zyaList = res.data;
					}
			    });
			},
			getZybList: function () {//本科专业
			    this.$http.post('/htgl/inf/zy/getZyByZycc',{zycc:'B'}).then(res => {
					if(res.data){
						this.zybList = res.data;
					}
			    });
			},
            getXkList: function () {
                this.$http.post('/htgl/inf/xk/yjxk').then(res => {
					if(res.data){
						this.xkaList = res.data;
					}
                });
            },
            save:function(){
                this.$validator.validateAll().then((result) => {
                    if (result) {//如果表单校验通过才可以保存
                        this.$http.post('/htgl/inf/zy/xg',this.model).then(res=>{
                            if(res.data){
                                this.$success("编辑专业成功",()=>{
									this.$router.go(-1);
                                });
                            }
                        })
                    }
                })
            }
        }

    }
</script>
<style scoped>

</style>
